import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const Unauthorized = () => {
  const handleClose = () => {
    window.close(); // closes the tab (will only work if opened via window.open or some browsers)
  };

  return (
    <Box
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="#f0f2f5"
    >
      <Card sx={{ maxWidth: 400, p: 3, boxShadow: 5 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <WarningAmberIcon sx={{ fontSize: 60, color: "#f44336", mb: 2 }} />
          <Typography variant="h5" color="error" gutterBottom>
            Unauthorized Access
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            sx={{ mb: 3 }}
          >
            You are not authorized to view this page. Please contact the
            administrator or close this window.
          </Typography>
          <Button variant="contained" color="error" onClick={handleClose}>
            Close
          </Button>
        </Box>
      </Card>
    </Box>
  );
};

export default Unauthorized;
